import React from 'react';

export default function ChallengeLinkIcon({ className = 'mt-0.5 w-3.5 shrink-0 text-center text-blue-600 dark:text-blue-400 text-[11px]' }) {
	return <i className={`fa-solid fa-user-group ${className}`} aria-hidden="true" />;
}
